import React, { useEffect, useState } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesDown } from '@fortawesome/free-solid-svg-icons';
import './style.css';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';

const HomePage = () => {
  const titleController = useAnimation();
  const [titleRef, titleInView] = useInView({ threshold: 0.03 });

  const controlsTeam = useAnimation();
  const [teamRef, teamInView] = useInView({ threshold: 0.1 });

  const controlsSponsor = useAnimation();
  const [sponsorRef, sponsorInView] = useInView({ threshold: 0.1 });

  const controlsGarage = useAnimation();
  const [garageRef, garageInView] = useInView({ threshold: 0.1 });

  const { t } = useTranslation();

  const [showScrollArrow, setShowScrollArrow] = useState(true);

  const carData = [
    {
      name: "FS DRAGON",
      year: "2015",
      path: "/garage/fsdragon",
      imageUrl: "https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Fotos%2FDragon%2Fcar_background.jpg?alt=media&token=b4845e0b-8f0b-407e-8f4d-1efce819f1d3"
    },
    {
      name: "FS FENIX",
      year: "2023",
      path: "/garage/fsfenix",
      imageUrl: "https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Fotos%2FFenix%2Ffsfenix_render3.png?alt=media&token=f6f6d07e-71a5-4524-9761-e3460a77c3fd"
    },
    {
      name: "FS FENIX EVO",
      year: "2024",
      path: "/garage/fsfenixevo",
      imageUrl: "https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Fotos%2FFenix%20Evo%2Fcarro_fspt.jpg?alt=media&token=c254dd19-2cd4-400c-9694-0b700ddab32d"
    },
    {
      name: "NOVA EV01",
      year: "2025",
      path: "/garage/fsnovaev01",
      imageUrl: "https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Fotos%2FNovaEV01%2FnovaEV01Render.png?alt=media&token=dd6df09b-42a4-45d2-b1c6-a387b1c78844"
    }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollArrow(window.scrollY <= 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (titleInView) {
      titleController.start({ opacity: 0 });
    } else {
      titleController.start({ opacity: 1 });
    }
  }, [titleController, titleInView]);

  useEffect(() => {
    if (teamInView) {
      controlsTeam.start({ opacity: 1, x: 0, transition: { duration: 0.5 } });
    } else {
      controlsTeam.start({ opacity: 0, x: -100, transition: { duration: 0.5 } });
    }
  }, [controlsTeam, teamInView]);

  useEffect(() => {
    if (sponsorInView) {
      controlsSponsor.start({ opacity: 1, x: 0, transition: { duration: 0.5, delay: 0.2 } });
    } else {
      controlsSponsor.start({ opacity: 0, x: -100, transition: { duration: 0.5 } });
    }
  }, [controlsSponsor, sponsorInView]);

  useEffect(() => {
    if (garageInView) {
      controlsGarage.start({ opacity: 1, x: 0, transition: { duration: 0.5, delay: 0.4 } });
    } else {
      controlsGarage.start({ opacity: 0, x: 100, transition: { duration: 0.5 } });
    }
  }, [controlsGarage, garageInView]);

  return (
    <div className="home-page">
      <div className="background-home-video">
        <div className="video-player-container">
          <video className='video-player' autoPlay loop muted>
            <source src="https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/fspt_video%20(2).mp4?alt=media&token=f769f0cc-ed41-4c45-adb0-7533a8ecd0dd" type="video/mp4" />
          </video>
          <div ref={titleRef}>
            <motion.div animate={titleController}>
              <div className="video-text-content">
                <h1 className="nova-title">Nova Formula Student</h1>
              </div>
            </motion.div>
          </div>
        </div>

        {showScrollArrow && (
          <motion.div
            className="scroll-indicator"
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
          >
            <FontAwesomeIcon icon={faAnglesDown} size="2x" color='white' />
          </motion.div>
        )}
      </div>

      <div className="black-section" ref={teamRef}>
        <div className="team-content">
          <h2 className='title-team'>{t('home.team')}</h2>
          <p className='content-team'>{t('home.team_desc1')}</p>
          <p className='content-team'>{t('home.team_desc2')}</p>
          <p className='content-team'>{t('home.team_desc3')}</p>
        </div>
        <motion.div className="team-photo" animate={controlsTeam} initial={{ opacity: 0, x: 100 }}>
          <img src='https://firebasestorage.googleapis.com/v0/b/novaformulastudent.appspot.com/o/Fotos%2Fteam_photo_2025.jpg?alt=media&token=7fb76067-f655-4e54-9680-4a0984848092' alt="Team" />
        </motion.div>
      </div>

      <div className="sponsors-section" ref={sponsorRef}>
        <div className="dark-glass-overlay-sponsor">
          <div className="sponsor-text-content">
            <h2 className='title-sponsor'>{t('home.sponsor_title')}</h2>
          </div>
          <motion.div
            animate={controlsSponsor}
            initial={{ opacity: 0, x: -100 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <Link className="icon-button-c" to="/partners">
              <div className='reach'>{t("home.reach_us")}</div>
            </Link>
          </motion.div>
        </div>
      </div>

      <div className="garage-home-section" ref={garageRef}>
        <div className="garage-home-content">
          <h2 className='title-garage'>{t('garage-page.page-title')}</h2>
          <p className='garage-content'>{t('garage-page.page-subtitle')}</p>
        </div>
        <motion.div
          className='garage-grid-container'
          animate={controlsGarage}
          initial={{ opacity: 0, x: 100 }}
        >
          {carData.map((car) => (
            <Link
              key={car.name}
              to={car.path}
              className='car-card'
              style={{ backgroundImage: `url(${car.imageUrl})` }}
            >
              <div className='car-card-overlay'>
                <div className='car-card-text'>
                  <h3>{car.name}</h3>
                  <p>{car.year}</p>
                </div>
              </div>
            </Link>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default HomePage;